import { appStore } from '@/store/app'
import { useUserStore } from '@/store/userStore'
import { useCommandContextStore } from '@/store/commandContext'

export function enrichCommandData(data: Record<string, any>): Record<string, any> {
  const app = appStore()
  const { organisationId } = useUserStore()
  const ctx = useCommandContextStore()

  const device = app.selectedRCObj ?? app.selectedDockObj

  return {
    ...data,
    deviceGroupID: device?.deviceGroupID ?? null,
    deviceGroupName: device?.deviceGroupName ?? null,
    organisationID: organisationId ?? null,
    projectID: ctx.projectID ?? (organisationId ? `${organisationId}_default` : 'default'),
    ...(ctx.tags.length ? { tags: ctx.tags } : {}),
    mediaFolderID: ctx.mediaFolderID,
  }
}
